import { createClient } from '@supabase/supabase-js'

// Environment-based Supabase configuration
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY

// Validate required environment variables
if (!supabaseUrl) {
  throw new Error('REACT_APP_SUPABASE_URL environment variable is required')
}

if (!supabaseAnonKey) {
  throw new Error('REACT_APP_SUPABASE_ANON_KEY environment variable is required')
}

// Validate configuration in development
if (process.env.NODE_ENV === 'development') {
  console.log('🔧 Supabase Config:', {
    url: supabaseUrl,
    usingLocalSupabase: supabaseUrl.includes('127.0.0.1'),
    hasCustomUrl: !!process.env.REACT_APP_SUPABASE_URL,
    hasCustomKey: !!process.env.REACT_APP_SUPABASE_ANON_KEY
  })
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey)